const context = require.context('@src', true, /^\.\/[\s\S]+\/router\/[\s\S]+\.js$/)
const keys = context.keys()
const routes = []
for (const i in keys) {
  const key = keys[i]
  if (key.indexOf('area-core') === -1) {
    const keyArr = key.split('/')
    var item = keyArr.pop() // 移除.
    item = item.split('.')[0]
    routes.push(context(key).default)
  }
}
routes.sort((a, b) => {
  return a.meta.sort - b.meta.sort
})
export default routes



// WEBPACK FOOTER //
// ./src/area-core/router/routesConf.js